/**
 * 系统中用到的常量
 * **/
var TYBM_Env = (function () {

    return {

        // 服务器域名
        ServerHost: process.env.NODE_ENV === 'production' ? '' : 'http://localhost:106',

        GetApiUrl: function (api_name) {
            var url = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:106';
            url += process.env.BASE_URL;
            url += "api";
            url += api_name;
            url += ".ashx";
            return url;
        }

    }
})();

export { TYBM_Env };
